import React from 'react';
import { ArrowRightIcon, CogIcon, CrosshairIcon, DropletIcon, GaugeIcon, Settings2Icon, ThermometerIcon, WindIcon, WrenchIcon, ZapIcon } from 'lucide-react';
import { services } from '../data/site';
const iconMap: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  gauge: GaugeIcon,
  droplet: DropletIcon,
  zap: ZapIcon,
  cog: CogIcon,
  wind: WindIcon,
  thermometer: ThermometerIcon,
  crosshair: CrosshairIcon,
  settings2: Settings2Icon,
  wrench: WrenchIcon
};
export function Services() {
  return <section id="services" className="w-full bg-chalk py-20 lg:py-28" data-id="element-166" data-mp="z3tq4rbns1my">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-167" data-mp="u736xv4k4pxb">
        <div className="flex flex-col gap-6 border-b border-black/10 pb-8 md:flex-row md:items-end md:justify-between" data-id="element-168" data-mp="q4gg9xjmhb1p">
          <div data-id="element-169" data-mp="l5wsrspdrr78">
            <p className="text-[12px] font-bold uppercase tracking-[0.18em] text-brand-dark" data-id="element-170" data-mp="l4bvhvbolu5o">
              What we do
            </p>
            <h2 className="mt-4 max-w-[620px] font-display text-[34px] font-extrabold leading-[1.08] tracking-[-0.02em] text-ink sm:text-[42px]" data-id="element-171" data-mp="g8dckn94h4cn">
              Full-service repair and maintenance, under one roof
            </h2>
          </div>
          <a href="#services" className="inline-flex shrink-0 items-center gap-2 self-start rounded-md border border-ink/20 px-5 py-3 text-sm font-semibold text-ink transition-colors duration-150 ease-out hover:border-ink md:self-auto" data-id="element-172" data-mp="2xcb6qmopck0i">
            View Services
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-173" data-mp="3u2k5o5tt7rpb" />
          </a>
        </div>

        <ul className="mt-px grid grid-cols-1 gap-px bg-black/10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-174" data-mp="3g2spbyftlz85">
          {services.map(service => {
          const Icon = iconMap[service.icon] ?? WrenchIcon;
          return <li key={service.name} className="bg-chalk" data-id="element-175" data-mp="24m2rp3pgqfq5">
                <a href="#request" className="group flex h-full flex-col gap-3 bg-chalk px-6 py-7 transition-colors duration-150 ease-out hover:bg-white lg:px-7 lg:py-8" data-id="element-176" data-mp="29lxf2xa14n6g">
                  <Icon className="h-6 w-6 text-brand-dark" aria-hidden="true" data-id="element-177" data-mp="1li8yv7onhrwv" />
                  <h3 className="font-display text-[19px] font-bold leading-snug tracking-tight text-ink" data-id="element-178" data-mp="1gpy0wadh0g6y">
                    {service.name}
                  </h3>
                  <p className="text-[14.5px] leading-relaxed text-steel/70" data-id="element-179" data-mp="16unvdcnv5qof">
                    {service.description}
                  </p>
                  <span className="mt-auto pt-4 text-[13px] font-semibold uppercase tracking-[0.08em] text-brand-dark" data-id="element-180" data-mp="11wmft1pnc9hp">
                    Request this service
                  </span>
                </a>
              </li>;
        })}
        </ul>

        <p className="mt-8 text-[14px] text-steel/60" data-id="element-181" data-mp="2s5we8qfolodz">
          Current promotions and seasonal specials change — call the shop for
          what is running right now.
        </p>
      </div>
    </section>;
}